/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroBlog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function EmprestimoGarantiaCarroBlog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-blog">
        <ContainerHome24>
          <div className="is-mobi">
            <h2 className="emp-garantia-carro-blog-titulo">Consulte nossos conteúdos</h2>
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`emp-garantia-carro-blog-slide ${className}`}>
                    <a
                      href="blog/como-usar-seu-veiculo-no-emprestimo-com-garantia.html"
                      target="_blank"
                      className="emp-garantia-carro-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-32/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-32/capa.jpg" />
                        <img
                          src="static/amp/blog/post-32/capa.jpg"
                          alt="carro de brinquedo com chave de carro e homem no fundo assinando um documento com veiculo no emprestimo com garantia"
                        />
                      </picture>
                      <div className="emp-garantia-carro-blog-card-textos">
                        <h3 className="emp-garantia-carro-blog-slide-titulo">
                          Saiba como usar seu veículo no empréstimo com garantia
                        </h3>
                        <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`emp-garantia-carro-blog-slide ${className}`}>
                    <a
                      href="blog/passos-para-organizar-sua-vida-financeira.html"
                      target="_blank"
                      className="emp-garantia-carro-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-25/capa.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-25/capa.jpg" />
                        <img
                          src="static/amp/blog/post-25/capa.jpg"
                          alt="Cofre no formato de porco  com um balão de pensamentos sobre educação financeira em uma superfície branca ao lado de quatro pilhas de moedas em sequencia em forma crescente."
                        />
                      </picture>
                      <div className="emp-garantia-carro-blog-card-textos">
                        <h3 className="emp-garantia-carro-blog-slide-titulo">
                          Passo a passo para organizar sua vida financeira
                        </h3>
                        <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`emp-garantia-carro-blog-slide ${className}`}>
                    <a
                      href="blog/como-solicitar-um-emprestimo-pessoal-online.html"
                      target="_blank"
                      className="emp-garantia-carro-blog-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-2/banner.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-2/banner.jpg" />
                        <img
                          src="static/amp/blog/post-2/banner.jpg"
                          alt="Mulher analisando as contas do mês"
                        />
                      </picture>
                      <div className="emp-garantia-carro-blog-card-textos">
                        <h3 className="emp-garantia-carro-blog-slide-titulo">
                          Como solicitar um empréstimo pessoal online?
                        </h3>
                        <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            <h2 className="emp-garantia-carro-blog-titulo">Consulte nossos conteúdos</h2>
            <div className="cards-desk">
              <a
                href="blog/como-usar-seu-veiculo-no-emprestimo-com-garantia.html"
                target="_blank"
                className="emp-garantia-carro-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-32/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-32/capa.jpg" />
                  <img
                    src="static/amp/blog/post-32/capa.jpg"
                    alt="carro de brinquedo com chave de carro e homem no fundo assinando um documento com veiculo no emprestimo com garantia"
                  />
                </picture>
                <div className="emp-garantia-carro-blog-card-textos">
                  <h3 className="emp-garantia-carro-blog-slide-titulo">
                    Saiba como usar seu veículo no empréstimo com garantia
                  </h3>
                  <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/passos-para-organizar-sua-vida-financeira.html"
                target="_blank"
                className="emp-garantia-carro-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-25/capa.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-25/capa.jpg" />
                  <img
                    src="static/amp/blog/post-25/capa.jpg"
                    alt="Cofre no formato de porco  com um balão de pensamentos sobre educação financeira em uma superfície branca ao lado de quatro pilhas de moedas em sequencia em forma crescente."
                  />
                </picture>
                <div className="emp-garantia-carro-blog-card-textos">
                  <h3 className="emp-garantia-carro-blog-slide-titulo">
                    Passo a passo para organizar sua vida financeira
                  </h3>
                  <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/como-solicitar-um-emprestimo-pessoal-online.html"
                target="_blank"
                className="emp-garantia-carro-blog-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-2/banner.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-2/banner.jpg" />
                  <img
                    src="static/amp/blog/post-2/banner.jpg"
                    alt="Mulher analisando as contas do mês"
                  />
                </picture>
                <div className="emp-garantia-carro-blog-card-textos">
                  <h3 className="emp-garantia-carro-blog-slide-titulo">
                    Como solicitar um empréstimo pessoal online?
                  </h3>
                  <p className="emp-garantia-carro-blog-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroBlog;
